import { globalAppConfig } from "src/app/configs/global-app-config";
import { CoreService } from "./core.service";
import { ResponseData } from "src/app/@types/interfaces/get.response";
import { AddressSearchResponse } from "src/app/@types/interfaces/mar-api.interface";
import { transformMarResponse } from "src/app/utils/address.utils";

class AddressSearchService extends CoreService {
  async searchAddress(
    request: string
  ): Promise<ResponseData<AddressSearchResponse>> {
    return new Promise((resolve, reject) => {
      this.axios
        .post(
          globalAppConfig.marApiBaseUrl + globalAppConfig.marApiSearchPath,
          { address: request },
          {
            headers: {
              "Content-Type": "application/json",
              apikey: globalAppConfig.marApiApiKey,
            },
          }
        )
        .then((response) => {
          const marResponse = response.data;
          if (marResponse.Success) {
            const addresses = transformMarResponse(marResponse);
            resolve({
              success: true,
              message: "Address search completed",
              data: { addresses },
            });
          } else {
            resolve({
              success: false,
              message: marResponse.Message ?? "Search failed",
              data: { addresses: [] },
            });
          }
        })
        .catch((error) => {
          console.error("MAR API POST Error:", error.response?.data);
          reject(new Error("An error occurred during address search"));
        });
    });
  }
}

export const addressSearchService = new AddressSearchService();
